import { Boost, Empower, Engage, Scalability, Simplify, Support } from "../assets/images/images";

const MemberManagementData = [
    {
        title: "Informative Dashboard with Insights",
        description:
            "Make data-driven decisions with a real-time dashboard that provides actionable insights into member behavior, attendance, and financial performance. Monitor your gym’s health at a glance and make informed choices to boost retention and revenue.",
        icon: Simplify
    },
    {
        title: "Intuitive Point of Sale (PoS)",
        description:
            "Simplify payment processing with an easy-to-use PoS system. Record payments, associate them with memberships, and handle class or service fees efficiently—keeping everything in one place.",
        icon: Support
    },
    {
        title: "Slot-Based Membership Plans",
        description:
            "Offer flexible membership options with different pricing for various time slots. Whether it’s a discounted rate for off-peak hours or a premium package for peak times, customize your offerings to meet demand.",
        icon: Scalability
    },
    {
        title: "Member Management",
        description:
            "Stay organized with a comprehensive member management system. Keep track of profiles, membership plans, and attendance records in one easy-to-use platform.",
        icon: Empower
    },
    {
        title: "Easy Check-in",
        description:
            "Streamline your check-in process with a simple and efficient system that allows members to check in quickly as they arrive at the gym.",
        icon: Engage
    },
    {
        title: "Membership Add-ons",
        description:
            "Increase revenue by offering additional services like personal training, nutritional counseling, or gym merchandise, all of which can be easily added to members’ plans.",
        icon: Boost
    }
];

export default MemberManagementData;
